import { z } from 'zod';

const envSchema = z.object({
  VITE_SUPABASE_URL: z.string().url(),
  VITE_SUPABASE_ANON_KEY: z.string().min(1),
  VITE_SITE_URL: z.string().url(),
  VITE_GITHUB_REPO: z.string().regex(/^[^/]+\/[^/]+$/, 'Expected "owner/repo"'),
  VITE_AUTH_SERVER_URL: z.string().url(),
});

const parsed = envSchema.safeParse(import.meta.env);

if (!parsed.success) {
  const issues = parsed.error.issues
    .map((i) => `  - ${i.path.join('.')}: ${i.message}`)
    .join('\n');
  throw new Error(`Invalid environment variables:\n${issues}\n\nSee .env.example.`);
}

export const env = parsed.data;
export const APP_VERSION = __APP_VERSION__;
